import React, { Component, Fragment } from 'react'
import Cookies from 'universal-cookie';
import Header from './Header';

export class Kiosko extends Component {
    constructor(props) {
        super(props);
        this.cookies = new Cookies();
        var kios=null;
        if(this.cookies.get("kiosko")!==undefined){
            if(this.cookies.get("kiosko")=='true'){
                kios=true;
            }else{
                kios=false;
            }
        }else{
            kios=false;
        }

        this.usuarios=[{user:"ECCO_G1_MRD", "pass": "#721.86"},{user:"ECCO_G2_MQD", "pass": "#682.126"},{user:"ECCO_G3_NRD", "pass": "#804.e06"},
{user:"ECCO_G4_NQD", "pass": "#816.84"},{user:"ECCO_G5_GRS", "pass": "#7e6.283"}]

        this.state = {user: '',pass:'',kiosko:kios,usuarioopassinc:false};
        this.handleuserChange = this.handleuserChange.bind(this);
        this.handlepassChange = this.handlepassChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }
    
      handleuserChange(event) {
        this.setState({user: event.target.value});
      }

      handlepassChange(event) {
        this.setState({pass: event.target.value});
      }
    
      handleSubmit(event) {
        var today = new Date(2023, 12, 1);
        var upi=true;
        for(let i = 0; i < this.usuarios.length; i++){
            if(this.usuarios[i]["user"]==this.state.user && this.usuarios[i]["pass"]==this.state.pass){
                if(this.cookies.get("kiosko")!==undefined){
                    if(this.cookies.get("kiosko")=='true'){
                        this.cookies.set('kiosko', 'false', { path: '/',expires: today});
                        this.setState({kiosko: false});
                    }else{
                        this.cookies.set('kiosko', 'true', { path: '/',expires: today});
                        this.setState({kiosko: true});
                    }
                }else{
                    this.cookies.set('kiosko', 'true', { path: '/',expires: today});
                    this.setState({kiosko: false});
                }
                this.props.history.push('/')
                upi=false;
                break; 
            }
        }
        this.setState({usuarioopassinc: upi});
        event.preventDefault();
      }

    render() {
        return (
        <Fragment>
            <Header/>
    <div className="container">
        <div className="row">
            <div className="col-sm-4">
                {this.state.kiosko ? (
                    <h2>Modo kiosko habilitado</h2>

                ):(
                    <h2>Modo kiosko no habilitado</h2>
                ) }
            </div>
        </div>
        <div className="row">
            <div className="col-sm-4">
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <input  className="form-control" placeholder="usuario" type="text" value={this.state.user} onChange={this.handleuserChange} />
                    </div>
                    <div className="form-group">
                        <input  className="form-control" placeholder="contraseña" type="password" value={this.state.pass} onChange={this.handlepassChange} />
                    </div>   
                        <input type="submit" value="Aceptar"/>
                </form>
            </div>
        </div>
        {this.state.usuarioopassinc ? (
            <div className="row">
                <div className="col-sm-4">
                    <div className="alert alert-danger" role="alert">
                        ¡Nombre de usuario y/o contraseña incorrectos!
                    </div>
                </div>
            </div>
        ):(<div className="row"> </div>) }
    </div>
        </Fragment>

        )
    }
}

export default Kiosko
